import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./pages/Auth/Login";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Dashboard from "./pages/Dashboard";
import AddPage from "./pages/ContentManagement/Page/AddPage";
import Pages from "./pages/ContentManagement/Page/Pages";
import AddSection from "./pages/ContentManagement/Sections/AddSection";
import Sections from "./pages/ContentManagement/Sections/Sections";
import Category from "./pages/Category/Category";
import AddProduct from "./pages/Products/AddProduct";
import AddRecipe from "./pages/Recipe/AddRecipe";
import Products from "./pages/Products/Products";
import Recipes from "./pages/Recipe/Recipes";
import Brand from "./pages/Products/Brands";
import Grade from "./pages/Products/Grade";
import ValueAddition from "./pages/Products/ValueAddition";
import Banner from "./pages/ContentManagement/banners/Banners";
import Orders from "./pages/Order/Orders";
import OrderDetail from "./pages/Order/OrderDetail";
import Coupons from "./pages/Products/Coupons";
import AddCoupon from "./pages/Products/AddCoupon";
import Setting from "./pages/Auth/Setting";
import { callApi } from "./api/callApi";
import { API_ENDPOINT, API_URL } from "./api/constant";
import { useDispatch, useSelector } from "react-redux";
import { IRole } from "./interfaces/user";
import { setRoles } from "./store/actions/actions";
import Users from "./pages/UserManagement/Users";
// import Drivers from "./pages/UserManagement/Drivers";
// import AddDriver from "./pages/UserManagement/AddDriver";
import MarketingScreen from "./pages/ContentManagement/Marketing/MarketingScreens";
import Unit from "./pages/Products/Units";
import Origin from "./pages/Products/Origin";
import DiscountProducts from "./pages/Products/DiscountProducts";
import ProductDetails from "./pages/Products/ProductDetails";
// import DriverDetails from "./pages/UserManagement/DriverDetails";
import ReportManagement from "./pages/ReportManagement";
import UserDetails from "./pages/UserManagement/UserDetails";
import Notifications from "./pages/Auth/Notifications";
import { getMessaging, onMessage } from 'firebase/messaging';
import Modal from "./components/UI/Modal/Modal";
import AbandonedCarts from "./pages/Order/AbandonedCarts";
import { getToken as getAuthToken, getCookies, setCookies } from './utility/helper';
import { requestForToken } from "./firebase-messaging";
import GiftHampers from "./pages/Products/GiftHampers";
import ProtectedRoute from "./components/Layout/AuthGuard/ProtectedRoute";
import UnProtectedRoute from "./components/Layout/AuthGuard/UnProtectedRoute";
import OrderMoniterDashboard from "./pages/Order/OrderMoniterDashboard";
import AddCategory from "./pages/Category/AddCategory";
import SEOListing from "./pages/SEO/SEOListing";
import AddSEO from "./pages/SEO/AddSEO";
import AddMeateryBox from "./pages/Products/AddMeateryBox";
import MeateryBoxDetails from "./pages/Products/MeateryBoxDetails";
import MeateryBoxes from "./pages/Products/TheMeateryBox";
import CategoriesManager from "./pages/Category/CategoryManager";

const App: React.FC = () => {
  const roles = useSelector((state: any) => state.root.roles)
  const [orderNotification, setOrderNotification] = useState<any>(null);
  const [modal, setModal] = useState<boolean>(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    if (roles.length === 0 || location.pathname.includes('dashboard')) {
      getAllRoles()

    }
    const initFCM = async () => {
      await updateFCMToken();
    };

    if ('serviceWorker' in navigator) {
      initFCM();
    }
  }, [location.pathname])

  const updateFCMToken = async () => {
    const token = await requestForToken();
    const existingToken = getCookies(import.meta.env.VITE_BUSINESS + "deviceToken");
    console.log({
      token,
      existingToken,
      getAuthToken: getAuthToken(),
      cookies: getCookies(import.meta.env.VITE_BUSINESS + "deviceToken")
    })
    if (getAuthToken() && token && existingToken !== token) {
      console.log("Updating FCM token: ", token);
      try {
        await callApi(API_URL + API_ENDPOINT.auth + 'user/update-device-token', {
          method: "POST",
          data: { deviceToken: token }
        });
        setCookies(import.meta.env.VITE_BUSINESS + "deviceToken", token);
      } catch (error: any) {
        console.log("Failed to update FCM token: ", error?.message)
      }
    }
  }

  const getAllRoles = async () => {
    try {
      const response: IRole[] = await callApi(API_URL + API_ENDPOINT.auth + 'roles', { method: "GET" });
      dispatch(setRoles(response))
    } catch (error: any) {
      console.log("Fetch roles failed: ", error?.message)
    }
  }
  const [isWindowVisible, setIsWindowVisible] = useState(true);
  const isWindowVisibleRef = useRef(isWindowVisible);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // Sync ref with state
  useEffect(() => {
    isWindowVisibleRef.current = isWindowVisible;
  }, [isWindowVisible]);

  // Pre-load audio and initialize
  useEffect(() => {
    // Pre-load audio
    audioRef.current = new Audio('/assets/images/order-rec.wav');
    audioRef.current.loop = true;
    audioRef.current.preload = 'auto';

    // Initialize notification permission
    Notification.requestPermission().then(permission => {
      console.log('Notification permission:', permission);
    });

    // Handle visibility
    const handleVisibilityChange = () => {
      const visible = document.visibilityState === 'visible';
      setIsWindowVisible(visible);
      isWindowVisibleRef.current = visible;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Handle messages
    const messaging = getMessaging();
    const unsubscribe = onMessage(messaging, (payload) => {
      try {
        const notificationData = JSON.parse(payload?.data?.data as string);
        console.log('Notification received:', notificationData);

        if (notificationData?.type === 'ORDER_INIT') {
          setOrderNotification(notificationData);

          // Use ref for current value
          if (isWindowVisibleRef.current) {
            setModal(true);
            startRingtone();
          }

          showBrowserNotification(notificationData);
        }
      } catch (error) {
        console.error('Error parsing notification:', error);
      }
    });

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      unsubscribe();
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  // Handle tab becoming visible
  useEffect(() => {
    if (isWindowVisible && orderNotification) {
      setModal(true);
      startRingtone();
    }
  }, [isWindowVisible, orderNotification]);

  const startRingtone = () => {
    if (!audioRef.current) return;

    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(error => {
      console.log('Auto-play blocked, click anywhere to play sound', error);
      const handleUserClick = () => {
        audioRef.current?.play();
        document.removeEventListener('click', handleUserClick);
      };
      document.addEventListener('click', handleUserClick);
    });
  };

  const showBrowserNotification = (data: any) => {
    if (Notification.permission === 'granted') {
      new Notification('New Order!', {
        body: `Order ID: ${data.id}`,
        icon: '/logo.png'
      });
    }
  };

  // Stop the ringtone and hide the notification
  const dismissNotification = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setOrderNotification(null);
  };


  return (
    <>
      <Routes>
        <Route element={<UnProtectedRoute />} >
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </Route>
        <Route element={<ProtectedRoute />} >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reports" element={<ReportManagement />} />
          <Route path="/users" element={<Users />} />
          {/* <Route path="/drivers" element={<Drivers />} />
          <Route path="/driver-details/:id" element={<DriverDetails />} /> */}
          <Route path="/user-details/:id" element={<UserDetails />} />
          {/* <Route path="/add-driver" element={<AddDriver />} /> */}
          {/* <Route path="/edit-driver/:id" element={<AddDriver />} /> */}
          <Route path="/add-page" element={<AddPage />} />
          <Route path="/pages" element={<Pages />} />
          <Route path="/add-section" element={<AddSection />} />
          <Route path="/edit-section/:id" element={<AddSection />} />
          <Route path="/sections" element={<Sections />} />
          <Route path="/banners" element={<Banner />} />
          <Route path="/marketing-screen" element={<MarketingScreen />} />
          <Route path="/categories" element={<Category />} />
          <Route path="/categories/add" element={<AddCategory />} />
          <Route path="/categories/edit/:id" element={<AddCategory />} />
          <Route path="/category-manager" element={<CategoriesManager />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/brands" element={<Brand />} />
          <Route path="/grade" element={<Grade />} />
          <Route path="/units" element={<Unit />} />
          <Route path="/origin" element={<Origin />} />
          <Route path="/value-addition" element={<ValueAddition />} />
          <Route path="/edit-product/:id" element={<AddProduct />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product-details/:id" element={<ProductDetails />} />
          <Route path="/add-recipe" element={<AddRecipe />} />
          <Route path="/edit-recipe/:id" element={<AddRecipe />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/order-details/:id" element={<OrderDetail />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/add-coupon" element={<AddCoupon />} />
          <Route path="/edit-coupon/:id" element={<AddCoupon />} />
          <Route path="/discount" element={<DiscountProducts />} />
          <Route path="/gift-hampers" element={<GiftHampers />} />
          <Route path="/settings" element={<Setting />} />
          <Route path="/notification-center" element={<Notifications />} />
          <Route path="/abandoned-carts" element={<AbandonedCarts />} />
          <Route path="/order-monitor" element={<OrderMoniterDashboard />} />
          <Route path="/seo" element={<SEOListing />} />
          <Route path="/add-seo" element={<AddSEO />} />
          <Route path="/edit-seo/:id" element={<AddSEO />} />
          <Route path="/meatery-boxes" element={<MeateryBoxes />} />
          <Route path="/add-meatery-box" element={<AddMeateryBox />} />
          <Route path="/edit-meatery-box/:id" element={<AddMeateryBox />} />
          <Route path="/meatery-box-details/:id" element={<MeateryBoxDetails />} />

        </Route>
      </Routes>
      <Modal
        show={modal}
        onClose={() => {
          setModal(false);
          dismissNotification();
        }}
        title={`New Order Received`}
      >
        <div className="text-center">
          <h4 className="text-primary">New Order Received</h4>
          <p>Order ID: {orderNotification?.id}</p>
          <p>Customer ID: {orderNotification?.userId}</p>

          <button
            className="btn btn-primary"
            onClick={() => {
              dismissNotification();
              setModal(false);
              navigate(`/order-details/${orderNotification?.id}`);
            }}
          >
            View Order
          </button>
        </div>
      </Modal>
    </>
  )
}

export default App
